import { render, staticRenderFns } from "./CPagina.vue?vue&type=template&id=3cb7439b&"
import script from "./CPagina.vue?vue&type=script&lang=js&"
export * from "./CPagina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports